"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateInterestPerEntry = exports.PatchPaymentPlanSchema = exports.CreatePaymentPlanSchema = exports.PaymentPlanEntrySchema = exports.getAmount = exports.PaymentPlansConfigSchema = exports.getCurrentPaymentPlan = exports.defaultPaymentPlansConfig = exports.PaymentPlanConsoleLogType = exports.Interval = exports.PaymentPlanEntryTypes = exports.PaymentPlanEntryStatus = exports.PaymentPlanLogType = exports.PaymentPlanStatus = void 0;
const Joi = __importStar(require("joi"));
const moment_1 = __importDefault(require("moment"));
const helpers_1 = __importDefault(require("../../economy/helpers"));
const vouchers_1 = require("../../economy/vouchers");
var PaymentPlanStatus;
(function (PaymentPlanStatus) {
    PaymentPlanStatus["CREATED"] = "CREATED";
    PaymentPlanStatus["ACTIVE"] = "ACTIVE";
    PaymentPlanStatus["FINISHED"] = "FINISHED";
    PaymentPlanStatus["CANCELED"] = "CANCELED";
    PaymentPlanStatus["DELETED"] = "DELETED";
})(PaymentPlanStatus || (exports.PaymentPlanStatus = PaymentPlanStatus = {}));
var PaymentPlanLogType;
(function (PaymentPlanLogType) {
    PaymentPlanLogType["ErrorSettled"] = "ERROR_SETTLED";
    PaymentPlanLogType["Settled"] = "SETTLED";
    PaymentPlanLogType["DeltaShift"] = "DELTA_SHIFT";
    PaymentPlanLogType["CancelPlan"] = "CANCEL_PLAN";
    PaymentPlanLogType["Activated"] = "ACTIVATED";
})(PaymentPlanLogType || (exports.PaymentPlanLogType = PaymentPlanLogType = {}));
var PaymentPlanEntryStatus;
(function (PaymentPlanEntryStatus) {
    PaymentPlanEntryStatus["PENDING"] = "PENDING";
    PaymentPlanEntryStatus["REMINDED"] = "REMINDED";
    PaymentPlanEntryStatus["SETTLED"] = "SETTLED";
    PaymentPlanEntryStatus["AWAITING"] = "AWAITING";
    PaymentPlanEntryStatus["ERRORSETTLED"] = "ERRORSETTLED";
    PaymentPlanEntryStatus["CANCELED"] = "CANCELED";
    PaymentPlanEntryStatus["OVERDUE"] = "OVERDUE";
})(PaymentPlanEntryStatus || (exports.PaymentPlanEntryStatus = PaymentPlanEntryStatus = {}));
var PaymentPlanEntryTypes;
(function (PaymentPlanEntryTypes) {
    PaymentPlanEntryTypes["UPFRONT"] = "UPFRONT";
    PaymentPlanEntryTypes["NORMAL"] = "NORMAL";
    PaymentPlanEntryTypes["REST"] = "REST";
})(PaymentPlanEntryTypes || (exports.PaymentPlanEntryTypes = PaymentPlanEntryTypes = {}));
var Interval;
(function (Interval) {
    Interval["WEEK"] = "WEEK";
    Interval["TWO-WEEKS"] = "TWO-WEEKS";
    Interval["MONTH"] = "MONTH";
    Interval["TWO-MONTHS"] = "TWO-MONTHS";
    Interval["QUARTERLY"] = "QUARTERLY";
})(Interval || (exports.Interval = Interval = {}));
var PaymentPlanConsoleLogType;
(function (PaymentPlanConsoleLogType) {
    PaymentPlanConsoleLogType["REMINDER"] = "reminder";
    PaymentPlanConsoleLogType["DEADLINE"] = "deadline";
    PaymentPlanConsoleLogType["CANCEL"] = "cancel";
    PaymentPlanConsoleLogType["HANDLER"] = "handler";
    PaymentPlanConsoleLogType["SETTLECARDS"] = "settle-cards";
    PaymentPlanConsoleLogType["SETTLEBSANDLS"] = "settle-bs-and-ls";
    PaymentPlanConsoleLogType["SettleRanTwice"] = "settle-ran-twice";
})(PaymentPlanConsoleLogType || (exports.PaymentPlanConsoleLogType = PaymentPlanConsoleLogType = {}));
exports.defaultPaymentPlansConfig = {
    plans: [
        {
            id: '300be1dd-63cb-43f0-a110-eabaa0416297',
            interval: Interval.MONTH,
            duration: 3,
        },
        {
            id: 'e38c6d93-09d9-40d5-9611-1324c9ea9c83',
            interval: Interval.MONTH,
            duration: 6,
        },
        {
            id: '3cd046f4-650d-43bd-9091-43d12e9eb8ea',
            interval: Interval.MONTH,
            duration: 9,
        },
        {
            id: 'c575de9e-25a3-4b64-ad7b-402ffb40d9d1',
            interval: Interval.MONTH,
            duration: 12,
        },
    ],
    minEntryAmount: 5000,
    disablePaymentPlans: false,
    requireCentralRegisterId: false,
};
const getCurrentPaymentPlan = (paymentPlans) => {
    if (!paymentPlans)
        return null;
    const currentActivePlan = paymentPlans.find((plan) => [PaymentPlanStatus.ACTIVE].includes(plan.status));
    if (currentActivePlan) {
        return currentActivePlan;
    }
    const currentCreatedPlan = paymentPlans.find((plan) => [PaymentPlanStatus.CREATED].includes(plan.status));
    if (currentCreatedPlan) {
        return currentCreatedPlan;
    }
    const currentPlan = paymentPlans.find((plan) => [PaymentPlanStatus.FINISHED].includes(plan.status));
    return currentPlan || null;
};
exports.getCurrentPaymentPlan = getCurrentPaymentPlan;
exports.PaymentPlansConfigSchema = Joi.object({
    plans: Joi.array().items(Joi.object({
        interval: Joi.string()
            .valid(...Object.values(Interval))
            .required(),
        duration: Joi.number().required(),
        id: Joi.string().uuid().required(),
    })),
    disablePaymentPlans: Joi.boolean(),
    requireCentralRegisterId: Joi.boolean(),
    minEntryAmount: Joi.number().allow(null).required(),
    activationDeadlineDays: Joi.number().allow(null),
});
exports.getAmount = {
    upfront: (plan) => {
        const entry = plan.find((p) => p.type === PaymentPlanEntryTypes.UPFRONT);
        return entry && entry.amount;
    },
    entry: (plan) => {
        const entry = plan.find((p) => p.type === PaymentPlanEntryTypes.NORMAL);
        return entry && entry.amount;
    },
    total: (plan) => plan.reduce((acc, entry) => acc + (entry.amount || 0), 0),
    rest: (plan) => {
        const entry = plan.find((p) => p.type === PaymentPlanEntryTypes.REST);
        return entry && entry.amount;
    },
};
exports.PaymentPlanEntrySchema = Joi.object({
    amount: Joi.number().required(),
    cancel: Joi.string().required(),
    date: Joi.string().required(),
    reminder: Joi.string().required(),
    deadline: Joi.string().required(),
    type: Joi.string()
        .valid(...Object.values(PaymentPlanEntryTypes))
        .required(),
});
exports.CreatePaymentPlanSchema = Joi.object({
    activationTrigger: Joi.boolean(),
    selectedPaymentPlanId: Joi.string().uuid(),
    plan: Joi.array().items(exports.PaymentPlanEntrySchema).allow(null),
    config: Joi.object({
        startDate: Joi.string().required(),
        interval: Joi.string()
            .valid(...Object.values(Interval))
            .required(),
        duration: Joi.number().allow(null),
        amount: Joi.number().allow(null),
        amountUpfront: Joi.number().allow(null),
        dateUpfront: Joi.string().allow(null),
        interestFree: Joi.object({
            from: Joi.string().required(),
            to: Joi.string().required().allow(null),
        }).allow(null),
    }).allow(null),
});
exports.PatchPaymentPlanSchema = Joi.object({
    status: Joi.string().valid(...Object.values(PaymentPlanStatus)),
});
const calculateInterestPerEntry = (vouchers, documents, expirationSettings, entries, index) => {
    const entry = entries[index];
    const previousEntry = entries[index - 1];
    if (!entry)
        throw 'Could not find entry with that index';
    if (!previousEntry) {
        const _vouchersToday = helpers_1.default.interest.calculate(helpers_1.default.vouchers.postProcessing(vouchers, {
            includeDeletedVouchers: false,
            includeExpiredVouchers: false,
            includeIrrecoverableVouchers: false,
        }), documents, expirationSettings, (0, moment_1.default)().format());
        const interestBalanceToday = helpers_1.default.overview.balanceCategory(_vouchersToday, vouchers_1.VoucherCategory.INTEREST);
        return interestBalanceToday - (entry.interestAmount || 0);
    }
    else {
        return (previousEntry.interestAmount || 0) - (entry.interestAmount || 0);
    }
};
exports.calculateInterestPerEntry = calculateInterestPerEntry;
//# sourceMappingURL=index.js.map